import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/bottom-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4274f6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"center\" data-v-4274f6fa><div class=\"text\" data-v-4274f6fa>平台简介</div><div class=\"text\" data-v-4274f6fa>联系我们</div><div class=\"text\" data-v-4274f6fa>版权声明</div><div class=\"text\" data-v-4274f6fa>平台公众号</div></div><div class=\"info\" data-v-4274f6fa><img src=\"" + _imports_0 + "\" alt=\"\" class=\"icoimg\" data-v-4274f6fa><span data-v-4274f6fa>京公网安备 11010802020185号</span><span class=\"info-text\" data-v-4274f6fa>京ICP备15011138号</span><span data-v-4274f6fa>版权所有：中国招标公共服务平台有限公司</span></div>", 2)
const _hoisted_4 = { class: "info" }

import { reactive, toRefs, ref, onMounted, nextTick, onUnmounted } from 'vue'




export default /*#__PURE__*/_defineComponent({
  __name: 'bottom',
  setup(__props) {

const cnzzContent = ref('');


let timerId = null;
var currentUrl = window.location.href;

// 定时器执行的函数  
const checkCnzzLinks = () => {

  let cnzzDiv = {}
  // 检查地址中是否包含 "remotebidevaluation.cebpubservice.com"
  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
     cnzzDiv = document.getElementById('cnzz_stat_icon_1281408062');
  } else {
     cnzzDiv = document.getElementById('cnzz_stat_icon_1281408017');
  }


  if (!cnzzDiv) return;

  const links = cnzzDiv.querySelectorAll('a');
  const linkTexts = Array.from(links).map(link => link.textContent.trim());

  if (linkTexts.length > 0 && cnzzContent.value.trim() === '') {
    const links = cnzzDiv.querySelectorAll('a');
    Array.from(links).map(link => link.textContent.trim()).forEach(link => {
      cnzzContent.value += link;
    });
  }

  // 如果cnzzContent已经有值，则停止定时器  
  if (cnzzContent.value.trim() !== '') {
    clearInterval(timerId);

    timerId = null;

  }
};





onMounted(() => {



  const cnzzDiv = document.createElement('div');

  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
    cnzzDiv.id = 'cnzz_stat_icon_1281408062';
  } else {
    cnzzDiv.id = 'cnzz_stat_icon_1281408017';
  }





  cnzzDiv.style.fontSize = '16px';
  cnzzDiv.style.width = '100%';
  cnzzDiv.style.textAlign = 'center';
  cnzzDiv.style.display = 'none'; // 或者根据需求设置  

  // 创建一个 script 元素  
  const cnzzScript = document.createElement('script');

  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
    cnzzScript.src = 'https://s4.cnzz.com/z.js?id=1281408062&online=1&show=line';
  } else {
    cnzzScript.src = 'https://s4.cnzz.com/z.js?id=1281408017&online=1&show=line';
  }




  

  cnzzScript.type = 'text/javascript';

  // 选择一个父元素来插入这些元素，这里以 #app 为例  
  const mountPoint = document.getElementById('app');
  mountPoint.appendChild(cnzzDiv);



  // 插入 script 元素  
  document.body.appendChild(cnzzScript);


  timerId = setInterval(checkCnzzLinks, 1000);




});

// 组件卸载时断开观察者，避免内存泄漏  
onUnmounted(() => {
  clearInterval(timerId);


});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(cnzzContent.value), 1)
      ])
    ])
  ]))
}
}

})